export default "__VITE_ASSET___GAlhBS1__"